// src/config.js
const AppConfig = {
    title: "Kurd zhin - کورد ژین",
    paragraph: "…",
    img: "https://i.postimg.cc/JhDWwj6t/Screenshot-20260601-124027-Tik-Tok.jpg",
    url: "kurdzhin",
    id: "04060726"
};

export default AppConfig;